import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	titleNonFinal: {
		id: 'eoc-changeboarding.transition-home.left.title-non-final',
		defaultMessage: 'Shifting from Opsgenie to Jira Service Management',
		description: 'Transition home left hand side title',
	},
	descriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.left.description-non-final',
		defaultMessage:
			'Here’s a guide with everything that you must know and do to complete your shift from Opsgenie to Jira Service Management. ',
		description: 'Transition home left hand side description',
	},
	getMoreHelpNonFinal: {
		id: 'eoc-changeboarding.transition-home.left.get-more-help-non-final',
		defaultMessage: 'Get more help with shifting',
		description: 'Transition home left hand side get more help link',
	},
});
